export default __webpack_public_path__ + "static/media/RightSignIcon.7a32a074.svg";